<template>
    <div class="form-group">
        <label v-if="label">{{ label }}</label>
        
        <ValidationProvider :name="name" :rules="rules" v-slot="{ errors }">
            <multiselect
                :value="value"
                @input="handleInput"
                @change="handleChange"
                :placeholder="placeholder || label"
                :label="optionLabel"
                :track-by="trackBy"
                :options="options"
                :multiple="multiple"
                :close-on-select="closeOnSelect"
                :searchable="searchable"
                :disabled="disabled"
                v-bind="$attrs"
                :class="{'is-invalid': errors[0]}"
            />
            
            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;">
                <b>{{ errors[0].charAt(0).toUpperCase() + errors[0].slice(1).toLowerCase() }}</b>
            </span>
            
            <span v-if="apiValidationError" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;">
                <b>{{ Array.isArray(apiValidationError) ? apiValidationError.join(', ') : apiValidationError }}</b>
            </span>
        </ValidationProvider>
    </div>
</template>

<script setup>
    const props = defineProps({
        label: String,
        name: String,
        rules: [String, Object],
        value: [String, Number, Array, Object],
        options: {
            type: Array,
            default: () => []
        },
        optionLabel: {
            type: String,
            default: 'label'
        },
        trackBy: {
            type: String,
            default: 'id'
        },
        placeholder: String,
        multiple: {
            type: Boolean,
            default: false
        },
        closeOnSelect: {
            type: Boolean,
            default: true
        },
        searchable: {
            type: Boolean,
            default: true
        },
        disabled: Boolean,
        apiValidationError: [String, Array]
    });

    const emit = defineEmits(['input']);

    const handleInput = value => {
        emit('input', value);
    };

    const handleChange = value => {
        emit('change', value);
    };

</script>

<script>
    export default {
        inheritAttrs: false
    };
</script>

<style scoped>
    .is-invalid .multiselect__tags {
        border-color: #dc3545;
    }
    
    .form-group {
        position: relative;
    }
    .multiselect__content-wrapper {
        z-index: 9999 !important;
    }
</style>

